import React, { lazy } from 'react';
import { Route, Routes } from 'react-router-dom';
import { Pages } from 'core/pages';

const Dashboard = lazy(() => import('./Dashboard'));
const List = lazy(() => import('./List'));
const Create = lazy(() => import('./Create'));
const ResourcePage = lazy(() => import('./ResourcePage'));
const Versions = lazy(() => import('./Versions'));
const Update = lazy(() => import('./Update'));

export function ProductRoutes() {
  return (
    <Routes>
      <Route path={Pages.ecom.product.meta.path}>
        <Route
          index
          element={(<Dashboard />)}
        />
        <Route
          path={Pages.ecom.product.list.meta.path}
          element={(<List />)}
        />
        <Route
          path={Pages.ecom.product.create.meta.path}
          element={(<Create />)}
        />
        <Route
          path={Pages.ecom.product.read.meta.path}
          element={(<ResourcePage />)}
        />
        <Route
          path={Pages.ecom.product.versions.meta.path}
          element={(<Versions />)}
        />
        <Route
          path={Pages.ecom.product.update.meta.path}
          element={(<Update />)}
        />
      </Route>
    </Routes>
  );
}
